import React from "react";

/*
 * MicroLabel — the caption voice ("PRAYAGRAJ, INDIA", "PAGES", "NOW LIVE").
 *
 *   <MicroLabel as="p">PRAYAGRAJ, INDIA</MicroLabel>
 *
 * Applies the global `.micro` class from styles/primitives.css (Mona Sans 700,
 * 11px, uppercase, .06em tracking). It carries no styles of its own, so the
 * voice has exactly one definition; colour is inherited from the surface.
 *
 * Props
 *   as         "p" | "span" | "div" (any tag or component)   default "span"
 *   className  appended after "micro"
 *   ...rest    forwarded to the element (id, aria-*, data-*, style)
 *
 * Never colour a MicroLabel --lime on paper (1.11:1). Accented labels read
 * var(--accent-label), which is ink on paper and lime only on olive / void:
 *   <MicroLabel className="micro--accent">NOW LIVE</MicroLabel>
 *
 * Overriding from a module: styles.css (and with it primitives.css) is imported
 * AFTER App in src/index.js, so the global .micro rule lands LATER in the bundle
 * than every CSS module. A one-class module rule therefore loses to .micro on
 * the properties .micro sets (colour, size, weight, tracking, case). Override
 * two classes deep — `.card .label { color: … }` — as primitives.css requires.
 *
 * forwardRef so <Reveal as={MicroLabel}> can observe the element; without it
 * Reveal's ref stays null and the label is left at opacity 0 for good.
 */
const MicroLabel = React.forwardRef(function MicroLabel(
  { as: Tag = "span", className, children, ...rest },
  ref
) {
  return (
    <Tag ref={ref} className={className ? `micro ${className}` : "micro"} {...rest}>
      {children}
    </Tag>
  );
});

export default MicroLabel;
